function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUpIcon = function SvgUpIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M16 16H0V0h16Z",
    style: {
      fill: "none",
      opacity: 0.87
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 19V7.83l4.88 4.88a1.008 1.008 0 0 0 1.42 0 1 1 0 0 0 0-1.41l-6.59-6.59a1 1 0 0 0-1.41 0l-6.6 6.58a1 1 0 1 0 1.41 1.41L11 7.83V19a1 1 0 0 0 2 0Z",
    style: {
      fill: "#fff"
    },
    transform: "translate(-4 -4)"
  }));
};
export default SvgUpIcon;